(function () {
  var gaveta = function () { return document.getElementById('cart-drawer'); };
  var itens = function () { var g = gaveta(); return g && g.querySelector('cart-items-component'); };

  function atualizaContador() {
    fetch('/cart.js', {headers: {Accept: 'application/json'}}).then(function (r) { return r.json(); }).then(function (c) {
      document.dispatchEvent(new CustomEvent('cart:update', {detail: {resource: c}}));
    }).catch(function () {});
  }

  function abre() { var g = gaveta(); if (g && typeof g.open === 'function') { g.open(); return true; } return false; }

  document.addEventListener('submit', function (e) {
    var f = e.target;
    if (!(f instanceof HTMLFormElement) || !/\/cart\/add/.test(f.getAttribute('action') || '')) return;
    if (f.closest('product-form-component') || !gaveta()) return;
    e.preventDefault();
    var fd = new FormData(f), ci = itens(), sec = ci && ci.dataset.sectionId;
    if (e.submitter && e.submitter.name) fd.set(e.submitter.name, e.submitter.value || '');
    if (sec) fd.append('sections', sec);
    var fid = f.getAttribute('id');
    var botoes = [].slice.call(f.querySelectorAll('[type="submit"]'));
    if (fid) botoes = botoes.concat([].slice.call(document.querySelectorAll('[form="' + fid + '"][type="submit"]')));
    botoes.forEach(function (b) { b.setAttribute('aria-busy', 'true'); b.disabled = true; });
    fetch('/cart/add.js', {method: 'POST', body: fd, headers: {Accept: 'application/json'}})
      .then(function (r) { return r.json().then(function (j) { if (!r.ok) throw j; return j; }); })
      .then(function (j) {
        if (sec && j.sections && j.sections[sec]) {
          var doc = new DOMParser().parseFromString(j.sections[sec], 'text/html');
          var novo = doc.querySelector('.cart-drawer__inner'), velho = gaveta().querySelector('.cart-drawer__inner');
          if (novo && velho) velho.replaceWith(document.importNode(novo, true));
        }
        atualizaContador();
        if (!abre()) location.href = '/cart';
      })
      .catch(function (err) { alertaErro(f, (err && (err.description || err.message)) || 'Não foi possível adicionar. Tente de novo.'); })
      .finally(function () { botoes.forEach(function (b) { b.removeAttribute('aria-busy'); b.disabled = false; }); });
  }, true);

  function alertaErro(f, msg) {
    var p = f.querySelector('.rl-erro') || document.createElement('p');
    p.className = 'rl-erro'; p.textContent = msg; p.style.cssText = 'color:#B3261E;font-size:13px;margin:8px 0 0';
    f.appendChild(p); setTimeout(function () { p.remove(); }, 6000);
  }

  document.addEventListener('click', function (e) {
    var a = e.target.closest && e.target.closest('a.lt-sacola');
    if (!a || /\/cart$/.test(location.pathname)) return;
    if (abre()) e.preventDefault();
  });
})();

/* "Combine com o seu pedido" dentro da gaveta: produtos relacionados ao item que a pessoa já vai levar */
(function () {
  var reais = new Intl.NumberFormat('pt-BR', {style: 'currency', currency: 'BRL'});
  var gaveta = function () { return document.getElementById('cart-drawer'); };
  var montando = false;

  function cartao(p) {
    var v = (p.variants || []).filter(function (x) { return x.available; })[0];
    if (!v) return '';
    var img = p.featured_image ? (p.featured_image.indexOf('?') > -1 ? p.featured_image + '&width=200' : p.featured_image + '?width=200') : '';
    var de = p.compare_at_price > p.price ? '<s>' + reais.format(p.compare_at_price / 100) + '</s>' : '';
    return '<li class="rl-rec__it"><a href="' + p.url + '" class="rl-rec__img">' + (img ? '<img src="' + img + '" alt="" loading="lazy" width="72" height="72">' : '') + '</a>' +
      '<div class="rl-rec__txt"><a href="' + p.url + '">' + p.title + '</a><span><b>' + reais.format(p.price / 100) + '</b>' + de + '</span></div>' +
      '<button type="button" class="rl-rec__add" data-rl-add="' + v.id + '" aria-label="Adicionar ' + p.title.replace(/"/g, '') + '">+ Adicionar</button></li>';
  }

  function monta() {
    var g = gaveta(); if (!g || montando) return;
    var resumo = g.querySelector('.cart-drawer__summary'), lista = g.querySelector('.cart-drawer__items');
    if (!resumo || !lista || g.querySelector('.rl-rec')) return;
    montando = true;
    fetch('/cart.js', {headers: {Accept: 'application/json'}}).then(function (r) { return r.json(); }).then(function (c) {
      if (!c.items.length) { montando = false; return; }
      var noCarrinho = c.items.map(function (i) { return i.product_id; });
      var pid = c.items[c.items.length - 1].product_id;
      var ORDEM = ['iluminacao-de-natal', 'presepios', 'mantas-e-almofadas-de-natal', 'personagens-e-vilas', 'mesa-de-natal', 'arvore-e-enfeites'];
      /* 27/10: sugestão dinâmica: mostra a 1ª categoria da lista que ainda não está no carrinho (sem LED no carrinho = LEDs; com LED = presépios; e assim por diante) */
      function buscaCat(k) {
        if (k >= ORDEM.length) return Promise.resolve([]);
        return fetch('/collections/' + ORDEM[k] + '/products.json?limit=60').then(function (r) { return r.json(); }).then(function (j) {
          var todos = j.products || [];
          var jaTem = todos.some(function (p) { return noCarrinho.indexOf(p.id) > -1; });
          var livres = todos.filter(function (p) { return noCarrinho.indexOf(p.id) < 0; });
          if (jaTem || livres.length < 2) return buscaCat(k + 1);
          return livres;
        });
      }
      return buscaCat(0).then(function (todos) {
        var ps = todos.map(function (p) {
          var vs = (p.variants || []).map(function (v) { return {id: v.id, available: v.available, price: Math.round(parseFloat(v.price) * 100), compare_at_price: v.compare_at_price ? Math.round(parseFloat(v.compare_at_price) * 100) : 0}; });
          var v0 = vs.filter(function (v) { return v.available; })[0] || {};
          return {id: p.id, title: p.title, url: '/products/' + p.handle, featured_image: p.images && p.images[0] ? p.images[0].src : '', variants: vs, price: v0.price || 0, compare_at_price: v0.compare_at_price || 0};
        }).sort(function () { return Math.random() - 0.5; }).slice(0, 6);
        montando = false;
        if (!ps.length || g.querySelector('.rl-rec')) return;
        var box = document.createElement('div');
        box.className = 'rl-rec';
        box.innerHTML = '<p class="rl-rec__t">Complete o seu Natal</p><ul>' + ps.map(cartao).join('') + '</ul>';
        lista.appendChild(box);
      });
    }).catch(function () { montando = false; });
  }

  document.addEventListener('click', function (e) {
    var b = e.target.closest && e.target.closest('[data-rl-add]');
    if (!b) return;
    e.preventDefault();
    var g = gaveta(), ci = g && g.querySelector('cart-items-component'), sec = ci && ci.dataset.sectionId;
    b.disabled = true; b.textContent = 'Adicionando…';
    var fd = new FormData(); fd.append('id', b.getAttribute('data-rl-add')); fd.append('quantity', '1');
    if (sec) fd.append('sections', sec);
    fetch('/cart/add.js', {method: 'POST', body: fd, headers: {Accept: 'application/json'}}).then(function (r) { return r.json(); }).then(function (j) {
      if (sec && j.sections && j.sections[sec]) {
        var doc = new DOMParser().parseFromString(j.sections[sec], 'text/html');
        var novo = doc.querySelector('.cart-drawer__inner'), velho = g.querySelector('.cart-drawer__inner');
        if (novo && velho) velho.replaceWith(document.importNode(novo, true));
      }
      fetch('/cart.js').then(function (r) { return r.json(); }).then(function (c) { document.dispatchEvent(new CustomEvent('cart:update', {detail: {resource: c}})); });
    }).catch(function () { b.disabled = false; b.textContent = '+ Adicionar'; });
  });

  /* monta sempre que a gaveta abre ou o conteúdo dela é trocado */
  var obs = new MutationObserver(function () { var g = gaveta(); if (g && g.hasAttribute('open')) monta(); });
  function liga() { var g = gaveta(); if (!g) return; obs.observe(g, {attributes: true, attributeFilter: ['open'], childList: true, subtree: true}); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', liga); else liga();
})();

/* adiciona vários itens de uma vez (Complete o cantinho) e abre a gaveta */
window.rlAdicionaItens = function (itens) {
  var g = document.getElementById('cart-drawer'), ci = g && g.querySelector('cart-items-component'), sec = ci && ci.dataset.sectionId;
  var corpo = {items: itens}; if (sec) corpo.sections = sec;
  return fetch('/cart/add.js', {method: 'POST', headers: {'Content-Type': 'application/json', Accept: 'application/json'}, body: JSON.stringify(corpo)})
    .then(function (r) { return r.json(); })
    .then(function (j) {
      if (sec && j.sections && j.sections[sec]) {
        var doc = new DOMParser().parseFromString(j.sections[sec], 'text/html');
        var novo = doc.querySelector('.cart-drawer__inner'), velho = g.querySelector('.cart-drawer__inner');
        if (novo && velho) velho.replaceWith(document.importNode(novo, true));
      }
      return fetch('/cart.js').then(function (r) { return r.json(); }).then(function (c) { document.dispatchEvent(new CustomEvent('cart:update', {detail: {resource: c}})); });
    })
    .then(function () { if (g && typeof g.open === 'function') g.open(); else location.href = '/cart'; });
};

/* 27/10: barra de brinde no carrinho: acima de R$ 2.000, 1 presépio grátis (pedido dele) */
(function () {
  var META = 200000, reais = new Intl.NumberFormat('pt-BR', {style: 'currency', currency: 'BRL'}), t;
  var tag = '<svg viewBox="0 0 24 24" width="14" height="14" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M20.6 13.4 13.4 20.6a2 2 0 0 1-2.8 0L3 13V3h10l7.6 7.6a2 2 0 0 1 0 2.8Z"/><circle cx="7.5" cy="7.5" r="1.5"/></svg>';
  function aplica() {
    var g = document.getElementById('cart-drawer'), lista = g && g.querySelector('.cart-drawer__items');
    if (!lista) return;
    fetch('/cart.js', {headers: {Accept: 'application/json'}}).then(function (r) { return r.json(); }).then(function (c) {
      var b = g.querySelector('.rl-brinde');
      if (!c.item_count) { if (b) b.remove(); return; }
      if (!b) { b = document.createElement('div'); b.className = 'rl-brinde'; b.innerHTML = '<p></p><div class="rl-brinde__l"><div class="rl-brinde__bar"><i></i></div></div>'; lista.parentNode.insertBefore(b, lista); }
      var tot = c.items.reduce(function (s, i) { return s + (i.properties && i.properties._brinde ? 0 : i.final_line_price); }, 0); var falta = META - tot, ok = falta <= 0;
      b.classList.toggle('is-ok', ok);
      b.querySelector('p').innerHTML = '<svg viewBox="0 0 24 24" width="16" height="16" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M3.5 10.5h17v10h-17zM2.5 7h19v3.5h-19zM12 7v13.5M12 7c-1.6-3.3-5.4-3.6-5.4-1.4C6.6 7 9.6 7 12 7Zm0 0c1.6-3.3 5.4-3.6 5.4-1.4C17.4 7 14.4 7 12 7Z"/></svg>' + (ok ? 'Parabéns! Você ganhou o <b>Presépio de Bolso na Latinha</b> de presente.' : 'Compre acima de <b>R$ 2.000</b> e ganhe o <b>Presépio de Bolso na Latinha</b>. Faltam <b>' + reais.format(falta / 100) + '</b>.');
      b.querySelector('i').style.width = Math.max(4, Math.min(100, tot / META * 100)) + '%';
    }).catch(function () {});
  }
  var obs = new MutationObserver(function (m) {
    if (m.every(function (x) { return x.target.closest && x.target.closest('.rl-brinde'); })) return;
    clearTimeout(t); t = setTimeout(aplica, 80);
  });
  function liga() { var g = document.getElementById('cart-drawer'); if (g) obs.observe(g, {attributes: true, attributeFilter: ['open'], childList: true, subtree: true}); }
  document.addEventListener('cart:update', function () { clearTimeout(t); t = setTimeout(aplica, 80); });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', liga); else liga();
})();

/* 27/10: seletor de quantidade embaixo do preço (coluna da direita) */
(function () {
  var t;
  function move() {
    var g = document.getElementById('cart-drawer'); if (!g) return;
    g.querySelectorAll('.cart-items__table-row').forEach(function (row) {
      var q = row.querySelector('.cart-items__quantity'), pr = row.querySelector('.cart-items__price');
      if (q && pr && q.parentNode !== pr) { pr.appendChild(q); }
    });
  }
  var obs = new MutationObserver(function () { clearTimeout(t); t = setTimeout(move, 30); });
  function liga() { var g = document.getElementById('cart-drawer'); if (g) { obs.observe(g, {childList: true, subtree: true}); move(); } }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', liga); else liga();
})();
/* 27/10: brinde automático: com R$ 2.000 em outros itens, coloca o Presépio de Bolso (o desconto automático da Shopify zera o preço); abaixo disso, tira só o brinde que o sistema colocou */
(function () {
  var GIFT = 67859958169787, META = 200000, ocupado = false, t;
  function refresca() {
    var g = document.getElementById('cart-drawer'), ci = g && g.querySelector('cart-items-component'), sec = ci && ci.dataset.sectionId;
    if (!sec) return fetch('/cart.js').then(function (r) { return r.json(); }).then(function (c) { document.dispatchEvent(new CustomEvent('cart:update', {detail: {resource: c}})); });
    return fetch('/?sections=' + sec).then(function (r) { return r.json(); }).then(function (j) {
      if (j[sec]) { var doc = new DOMParser().parseFromString(j[sec], 'text/html'); var n = doc.querySelector('.cart-drawer__inner'), o = g.querySelector('.cart-drawer__inner'); if (n && o) o.replaceWith(document.importNode(n, true)); }
      return fetch('/cart.js').then(function (r) { return r.json(); }).then(function (c) { document.dispatchEvent(new CustomEvent('cart:update', {detail: {resource: c}})); });
    });
  }
  function confere() {
    if (ocupado) return;
    fetch('/cart.js').then(function (r) { return r.json(); }).then(function (c) {
      var brinde = c.items.filter(function (i) { return i.properties && i.properties._brinde; })[0];
      var resto = c.items.reduce(function (s, i) { return s + (i.properties && i.properties._brinde ? 0 : i.final_line_price); }, 0);
      if (resto >= META && !brinde) {
        ocupado = true;
        return fetch('/cart/add.js', {method: 'POST', headers: {'Content-Type': 'application/json'}, body: JSON.stringify({items: [{id: GIFT, quantity: 1, properties: {_brinde: '1'}}]})}).then(refresca);
      }
      if (resto < META && brinde) {
        ocupado = true;
        return fetch('/cart/change.js', {method: 'POST', headers: {'Content-Type': 'application/json'}, body: JSON.stringify({id: brinde.key, quantity: 0})}).then(refresca);
      }
    }).catch(function () {}).finally(function () { setTimeout(function () { ocupado = false; }, 800); });
  }
  document.addEventListener('cart:update', function () { clearTimeout(t); t = setTimeout(confere, 300); });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', confere); else confere();
})();
